import { render, staticRenderFns } from "./wcrd_ex_fel.vue?vue&type=template&id=eb01b2c8&scoped=true&"
import script from "./wcrd_ex_fel.vue?vue&type=script&lang=js&"
export * from "./wcrd_ex_fel.vue?vue&type=script&lang=js&"
import style0 from "./wcrd_ex_fel.vue?vue&type=style&index=0&id=eb01b2c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb01b2c8",
  null
  
)

export default component.exports